import { useState, useEffect } from "react";
import useRanking from "../../hooks/useRanking";
import useUser from "../../hooks/useUser";
import toast, { Toaster } from "react-hot-toast";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { filterBy } from "@progress/kendo-data-query";
import "@progress/kendo-theme-default/dist/all.css";
import Select from "react-select";
import { formatNumber } from "../../utils/format";
import useKendoGridState from "../../hooks/useKendoGridState";

const Meses = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];

// Por default se muestra el mes anterior (ej. en agosto se muestra julio),
// salvo en enero: retroceder implicaría diciembre del año pasado, y este
// reporte solo consulta el año en curso, así que en enero se queda en enero.
const mesPorDefecto = () => {
  const mesActual = new Date().getMonth() + 1; // Enero = 1 ... Diciembre = 12
  const numeroMes = mesActual === 1 ? 1 : mesActual - 1;
  return Meses.find((m) => m.value === numeroMes);
};

export default function Ranking() {
  const { success, message, Posicion, RankingAddService } = useRanking();
  const { tokenFull, IdUser, Roles } = useUser();
  const [Desde, setDesde] = useState(mesPorDefecto);
  const { sort, setSort, filter, setFilter, page, pageChange } =
    useKendoGridState("folio", "desc");

  const buscarGanadores = (mes = Desde?.value) => {
    toast.loading("Registrando...");
    const data = new FormData();
    data.append("rol", Roles);
    data.append("user_id", IdUser);
    data.append("desde", mes);
    data.append("ano", new Date().getFullYear());

    RankingAddService(data, tokenFull);
  };

  useEffect(() => {
    buscarGanadores(mesPorDefecto().value);
  }, []);

  useEffect(() => {
    if (success) {
      toast.dismiss();
      toast.success(message);
    }
  }, [message, success]);

  return (
    <>
      <Toaster />
      <h2 className="titulo2">
        Lista de ganadores
        {Desde && ` — ${Desde.label} ${new Date().getFullYear()}`}
      </h2>
      <div className="row">
        <div className="col-md-4">
          <label>Mes</label>
          <Select
            value={Desde}
            onChange={(e) => {
              setDesde(e);
              buscarGanadores(e.value);
            }}
            options={Meses}
            placeholder={"Seleccionar mes"}
          />
        </div>
        <div className="col-md-4">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => buscarGanadores()}
            style={{ marginTop: 20 }}
          >
            Buscar
          </button>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-md-12">
          <Grid
            sortable={true}
            sort={sort}
            onSortChange={(e) => setSort(e.sort)}
            filterable={true}
            filter={filter}
            onFilterChange={(e) => setFilter(e.filter)}
            pageable={true}
            data={filterBy(
              Posicion.slice(page.skip, page.take + page.skip),
              filter
            )}
            skip={page.skip}
            take={page.take}
            total={Posicion.length}
            onPageChange={pageChange}
            style={{
              height: "620px",
            }}
          >
            <GridNoRecords>No hay informacion disponible</GridNoRecords>
            <GridColumn
              field="Lugar"
              filterable={false}
              format={null}
              cell={(e) => {
                const lugar = e.dataIndex + 1;
                return <td style={{ marginTop: 10 }}>{lugar}</td>;
              }}
            />
            <GridColumn
              field="Vendedor"
              filterable={false}
              format={null}
              cell={(e) => {
                const nombre = `${e.dataItem.nombre} ${e.dataItem.apellido_paterno} ${e.dataItem.apellido_materno}`;
                return <td style={{ marginTop: 10 }}>{nombre}</td>;
              }}
            />
            <GridColumn
              field="Puntos"
              filterable={false}
              format={null}
              cell={(e) => {
                const total = e.dataItem.puntos;
                return (
                  <td style={{ marginTop: 10, textAlign: "right" }}>{total}</td>
                );
              }}
            />
            {Roles === "Admin" && (
              <GridColumn
                field="Monto"
                filterable={false}
                format={null}
                cell={(e) => {
                  const lugar = e.dataIndex + 1;
                  let monto = 0;
                  if (lugar >= 1 && lugar <= 10) {
                    monto = 2000;
                  } else if (lugar >= 11 && lugar <= 20) {
                    monto = 1600;
                  } else if (lugar >= 21 && lugar <= 50) {
                    monto = 900;
                  } else if (lugar >= 51 && lugar <= 70) {
                    monto = 650;
                  } else if (lugar >= 71 && lugar <= 100) {
                    monto = 400;
                  }
                  return (
                    <td style={{ marginTop: 10, textAlign: "right" }}>
                      {"$" + formatNumber(monto)}
                    </td>
                  );
                }}
              />
            )}
          </Grid>
        </div>
      </div>
    </>
  );
}
